// Inline SVG icons for the green-coffee review views. Color is inherited via
// `currentColor` (set a Tailwind text-* class); `size` drives width/height.

interface IconProps {
  size?: number;
  className?: string;
}

function base(size: number, strokeWidth: number, className?: string) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
    'aria-hidden': true,
  };
}

export function SproutIcon({ size = 17, className }: IconProps) {
  return (
    <svg {...base(size, 2, className)}>
      <path d="M12 22V11" />
      <path d="M12 11C12 7 9 4 4 4c0 5 3 7 8 7z" />
      <path d="M12 13c0-3.3 2.7-6 6-6 0 3.3-2.7 6-6 6z" />
    </svg>
  );
}

export function CheckIcon({ size = 16, className }: IconProps) {
  return (
    <svg {...base(size, 3, className)}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export function CrossIcon({ size = 15, className }: IconProps) {
  return (
    <svg {...base(size, 2.6, className)}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

export function UpdateIcon({ size = 10, className }: IconProps) {
  return (
    <svg {...base(size, 2, className)}>
      <path d="M3.5 9a9 9 0 0114.9-3.4L23 10" />
      <polyline points="23 4 23 10 17 10" />
      <path d="M20.5 15a9 9 0 01-14.9 3.4L1 14" />
      <polyline points="1 20 1 14 7 14" />
    </svg>
  );
}

export function BackIcon({ size = 19, className }: IconProps) {
  return (
    <svg {...base(size, 2, className)}>
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  );
}

export function ChevronRightIcon({ size = 16, className }: IconProps) {
  return (
    <svg {...base(size, 2, className)}>
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

export function AlertIcon({ size = 15, className }: IconProps) {
  return (
    <svg {...base(size, 2, className)}>
      <path d="M10.3 3.5L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L14.7 3.5a2 2 0 00-3.4 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

export function CircleCheckIcon({ size = 15, className }: IconProps) {
  return (
    <svg {...base(size, 2, className)}>
      <circle cx="12" cy="12" r="9" />
      <polyline points="8.5 12.5 11 15 16 9" />
    </svg>
  );
}

export function PencilIcon({ size = 15, className }: IconProps) {
  return (
    <svg {...base(size, 2.2, className)}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z" />
    </svg>
  );
}

export function ChevronDownIcon({ size = 14, className }: IconProps) {
  return (
    <svg {...base(size, 2.4, className)}>
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
